<!-- Dialog container -->
<div *ngIf="paymentMethods?.length" class="dialog-container">
    <!-- Dialog header -->
    <div class="dialog-header p-16-20 flex_sb bg-fff">
        <!-- Dialog title -->
        <div class="dialog-header-title fs-24 clr-333 fw-700">
            {{ 'SELECT_PAYMENT_OPTION' | fallbackTranslate }}
        </div>
        <!-- Close button -->
        <div class="dialog-header-cross" (click)="cancelClicked()">
            <img [src]="images.CROSS" class="img-20" alt="close" />
        </div>
    </div>
    <!-- Payment options container -->
    <div class="payment-options-container flex flex_column gap-4">
        <!-- Payment options -->
        <div class="flex flex_column gap-3">
            <nz-radio-group [(ngModel)]="selectedPaymentMethod" class="flex flex_column gap-3">
                <ng-container *ngFor="let method of paymentMethods">
                    <div class="payment-options flex flex_sb" [ngClass]="{
                        selected: method?.id === selectedPaymentMethod
                    }">
                        <!-- Payment method name -->
                        <label nz-radio [nzValue]="method?.id" class="method-name" [ngClass]="{
                            selected: method?.id === selectedPaymentMethod
                        }">{{ method?.name }}</label>
                        <!-- Payment method image -->
                        <div class="flex flex-center gap-2">
                            <div *ngIf="method?.id === enum?.PAYMENT_METHOD?.ONLINE" class="fs-10">Via</div>
                            <img [src]="method.img" alt="payment options" />
                        </div>
                    </div>
                </ng-container>
            </nz-radio-group>

            <!-- Checkbox for automatic payments -->
            <div *ngIf="this.selectedPaymentMethod === enum?.PAYMENT_METHOD?.ONLINE && isMYEnvironment" class="flex-align-center gap-2 fs-12">
                <label nz-checkbox [(ngModel)]="reoccurChecked" (ngModelChange)="reoccurCheckHandler($event)"></label>
                <div class="fw-400">
                    {{ 'AUTHORIZE_PAYMENT' | fallbackTranslate }}
                    <span class="c-pointer fw-700 text-underline know-more" nz-popover
                        [nzPopoverContent]="contentTemplate" nzPopoverTrigger="click" nzPopoverPlacement="right"
                        [(nzPopoverVisible)]="visible">{{ 'KNOW_MORE' | fallbackTranslate }}
                    </span>
                </div>
            </div>
        </div>
        <!-- Next button -->
        <button nz-button (click)="proceedToPaymentPage()" class="pay-btn pay-btn--primary flex-center fs-16 fw-600"
            [nzLoading]="isLoading">{{
            'NEXT_BUTTON' | fallbackTranslate }}</button>
    </div>
</div>

<!-- Popover content template -->
<ng-template #contentTemplate>
    <div class="flex flex_column gap-3 how-it-works">
        <div class="flex flex_sb">
            <div class="fs-18 fw-700">{{ 'HOW_THIS_WORKS' | fallbackTranslate }}</div>
            <img (click)="closePopover()" [src]="images.MODAL_CLOSE" alt="modal close" class="c-pointer" />
        </div>
        <ul class="list-items">
            <li>{{ 'OPTION_FIRST' | fallbackTranslate }}</li>
            <li>{{ 'OPTION_TWO' | fallbackTranslate }}</li>
            <li>{{ 'OPTION_THIRD' | fallbackTranslate }} </li>
        </ul>
    </div>
</ng-template>